export default {
    user: {
        create: {
            title: "Nouvel utilisateur",
            model: {
                email: {
                    label: "E-mail",
                    placeholder: "Remplir l'e-mail"
                },
                name: {
                    label: "Nom",
                    placeholder: "Remplissez le nom"
                },
                country: {
                    label: "Pays",
                    placeholder: "Remplir le pays"
                },
                approval_manager_email: {
                    label: "Courriel du gestionnaire",
                    placeholder: "Remplir l'e-mail du gestionnaire",
                    errors: {
                        different: "L'e-mail du responsable d'approbation doit être différent de l'e-mail de l'utilisateur"
                    }
                }
            },
            cta: {
                submit: {
                    text: "Soumettre",
                    processing: "Soumission"
                },
                cancel: {
                    text: "Annuler"
                }
            }
        },
        country: {
            title: "Pays de l'utilisateur",
            header: "{email} n'a pas sélectionné de pays. Veuillez sélectionner son pays.",
            model: {
                country: {
                    label: "Pays",
                    placeholder: "Remplir le pays"
                }
            },
            cta: {
                submit: {
                    text: "Soumettre",
                    processing: "Soumission"
                },
                cancel: {
                    text: "Annuler"
                }
            }
        }
    }
}